import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { TerceroIndexComponent } from './TerceroIndex.component';
import { TerceroFormComponent } from './TerceroForm.component'
import { SucursalIndexComponent } from './SucursalIndex.component';
import { SucursalFormComponent } from './SucursalForm.component';
import { TerceroNewComponent } from './TerceroNew.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';

const routes = [
{
    path 	 : 'Tercero',
    component: TerceroIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Tercero',
          nombreFormulario : 'Terceros'
        } 
},
{
    path      : 'Tercero/:cnumcont',
    component: TerceroIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Tercero',
          nombreFormulario : 'Terceros'
        } 
},
{
    path      : 'Tercero/:cnumcont/:ctipid/:cnumid',
    component: TerceroFormComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Tercero',
          nombreFormulario : 'Editar Tercero'
        } 
},
{
    path      : 'TerceroNew/:cnumcont/:ctipid/:cnumid',
    component: TerceroNewComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Tercero',
          nombreFormulario : 'Crear Tercero'
        } 
},
{
    path      : 'Sucursal/:cnumcont/:ctipid/:cnumid/:vnombre/:desde',
    component: SucursalIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Tercero',
          nombreFormulario : 'Sucursales'
        } 
},
{
    path      : 'Sucursal/:cnumcont/:ctipid/:cnumid/:vnombre/:cidregter/:desde/:tipo',
    component: SucursalFormComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Tercero',
          nombreFormulario : 'Editar Tercero'
        } 
}
];

@NgModule({
    declarations: [
        TerceroIndexComponent,
        TerceroFormComponent,
        SucursalIndexComponent,
        SucursalFormComponent,
        TerceroNewComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports  : [
        TerceroIndexComponent,
        TerceroFormComponent,
        SucursalIndexComponent,
        SucursalFormComponent,
        TerceroNewComponent
    ]
})


export class TerceroModule

{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Tercero/Tercero.module.ts